module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapping"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', [_vm._v("尊敬的" + _vm._s(_vm.hcgInfo.name))]), _vm._v(" "), _c('p', [_vm._v("明天是胚胎移植日，请请合理安排全程，不要迟到。（具体移植时间以实际告知为准）")]), _vm._v(" "), _c('h4', [_vm._v("注意事项：")]), _vm._v(" "), _c('p', [_vm._v("必须带：双方的身份证和结婚证(两本) “原件”")]), _vm._v(" "), _c('p', [_vm._v("移植前适当憋尿，有尿感就可以了，以确保B超能显示子宫。  ")]), _vm._v(" "), _c('h4', [_vm._v("手术日流程安排（下图）：")]), _vm._v(" "), _vm._m(0, false, false)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('loading', {
    attrs: {
      "text": "加载中..."
    },
    model: {
      value: (_vm.loadingShow),
      callback: function($$v) {
        _vm.loadingShow = $$v
      },
      expression: "loadingShow"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "http://front.wh.jinxin-fertility.com/static/images/vipfet.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ee9749b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/vipMsg/vipFetMsg.vue
// module id = bzCs
// module chunks = 5